export enum ScriptLanguage {
    JavaScript = "JavaScript",
    AppleScript = "AppleScript",
    BashScript = "BashScript",
}

let uuid = 0;

function getUuid() {
    return uuid++;
}

async function runScript(scriptLanguage: ScriptLanguage, script: string, signature?: string): Promise<[any | null, any | null]> {
    return new Promise((resolve) => {
        const uuid = getUuid();
        //@ts-ignore
        window.electronCallbacks[uuid] = (result: any) => {
            //@ts-ignore
            delete window.electronCallbacks[uuid];
            if(result.success) {
                resolve([result.data, null]);
            } else {
                resolve([null, result.error]);
            }
        }
        //@ts-ignore
        window?.electronAPI.runScript(uuid, signature || "", scriptLanguage, script);
    });
}

/*
function sendSignalToWindow(windowName: string, signal: string) {
    return runScript(ScriptLanguage.JavaScript, `windows["${windowName}"].sendSignal("${signal}")`);

}
*/

function getWindowCustomData(key: string): any {
    try {
        //@ts-ignore
        return window?.electronAPI.getValueByKey(key) || "";
    } catch (error) {
        return "";
    }
}

async function openFileInFinder(filePath: string) {
    const script = `
        set filePath to POSIX file "${filePath}"
        tell application "Finder"
            activate
            reveal filePath
        end tell `;

    return runScript(ScriptLanguage.AppleScript, script);
}

async function openFileInPhotoshop(filePath: string) {

    const [photoshop, err] = await findPhotoshop();
    if(err) {
        return [null, err];
    }

    const script = `
        tell application "${photoshop}"
          activate
          open file "${filePath}"
        end tell
    `;

    return runScript(ScriptLanguage.AppleScript, script);
}


function getWindowPosition(name: string) {
    return runScript(ScriptLanguage.JavaScript, `const pos = windows["${name}"].getPosition(); const result = {x: pos[0], y: pos[1]}; return result;`);
}

function getWindowSize(name: string) {
    return runScript(ScriptLanguage.JavaScript, `const size = windows["${name}"].getSize(); const result = {width: size[0], height: size[1]}; return result;`);
}

function setWindowPosition(name: string, x: number, y: number) {
    return runScript(ScriptLanguage.JavaScript, `windows["${name}"].setPosition(${x}, ${y})`);
}

function openNewWindow(name: string, url: string, settings = {}, customData = {}) {
    let defaultSettings = {
        name: name,
        url: url,
        titleBarStyle: "hidden",
        width: 800,
        height: 600,
        frame: true,
        resizable: true,
        modal: false,
        alwaysOnTop: false,
        minimizable: true,
        maximizable: true,
        fullscreen: false,
        fullscreenable: true,
        kiosk: false,
        vibrancy: 'hud',
        transparent: true,
        spellcheck: false,
        offscreen: false,
        closable: true,
        movable: true,
        excludedFromShownWindowsMenu: false,
        title: name,
    }
    settings = {...defaultSettings, ...settings};

    //@ts-ignore
    window?.electronAPI.openNewWindow(settings, customData);
}

function findPhotoshop() {
    const script = `const folderToPhotoshopName = {
            "Adobe Photoshop CC 2018": "Adobe Photoshop CC 2018",
            "Adobe Photoshop CC 2019": "Adobe Photoshop CC 2019",
            "Adobe Photoshop CC 2020": "Adobe Photoshop CC 2020",
            "Adobe Photoshop 2021": "Adobe Photoshop 2021",
            "Adobe Photoshop 2022": "Adobe Photoshop 2022",
            "Adobe Photoshop 2023": "Adobe Photoshop 2023",
            "Adobe Photoshop 2024": "Adobe Photoshop 2024",
            "Adobe Photoshop 2025": "Adobe Photoshop 2025",
            "Adobe Photoshop 2026": "Adobe Photoshop 2026",
        };

        const applicationsDir = "/Applications/";
        let photoshopName = "";

        for (const folder in folderToPhotoshopName) {
            if (fs.existsSync(path.join(applicationsDir, folder))) {
                photoshopName = folderToPhotoshopName[folder];
                break;
            }
        }
        
        return photoshopName;
    `;

    return electron.runScript(ScriptLanguage.JavaScript, script);
}

function isMountAccessible(value){

    //@ts-ignore
    return window?.electronAPI.isMountAccessible(value);
}


/*
const userPath = app.getPath('home');
const documentsPath = app.getPath('documents');
const downloadsPath = app.getPath('downloads');

const fs = require('fs');
const unzipper = require('unzipper');

const zipFilePath = '/path/to/your/file.zip';
const outputDir = '/path/to/output/directory';

fs.createReadStream(zipFilePath)
  .pipe(unzipper.Extract({ path: outputDir }))
  .on('close', () => {
    
  })
  .on('error', (error) => {
    console.error('Fehler beim Entpacken der ZIP-Datei:', error);
  });
 */





export const electron = {runScript, openFileInFinder, openFileInPhotoshop, openNewWindow, getWindowPosition, setWindowPosition, getWindowSize, getWindowCustomData, isMountAccessible}